/**
 * The State
 *
 * @type { Object }
 */
const initialState = () => {
	return {
		product: {
			passengers: null,
			deck: null,
			cabin: null,
		},

		steps: {
			overview: true,
			passengers: false,
			deck: false,
			cabin: false,
			order: false,
		},
	}
}

export default initialState;


// WEBPACK FOOTER //
// ./src/store/product/state.js